<template>
  <header class="site-header">
    <div class="container">
      <div class="logo-container">
        <!-- Logo placeholder -->
        <div class="logo-placeholder">
          <img src="/images/logo.png" alt="Logo" class="logo-img" />
        </div>
      </div>
      
      <!-- Desktop Navigation -->
      <nav class="desktop-nav">
        <router-link to="/?legacy=1" class="nav-item" :class="{ active: isActive('/') }">网站首页</router-link>
        <router-link to="/about" class="nav-item" :class="{ active: isActive('/about') }">关于我们</router-link>
        <router-link to="/news" class="nav-item" :class="{ active: isActive('/news') }">新闻资讯</router-link>
        <router-link to="/services" class="nav-item" :class="{ active: isActive('/services') }">我们的服务</router-link>
        <router-link to="/verification" class="nav-item" :class="{ active: isActive('/verification') }">报告查真伪</router-link>
      </nav>

      <!-- Mobile Menu Button -->
      <div class="mobile-menu-btn" @click="toggleMenu">
        <span class="bar" :class="{ open: isMenuOpen }"></span>
        <span class="bar" :class="{ open: isMenuOpen }"></span>
        <span class="bar" :class="{ open: isMenuOpen }"></span>
      </div>

      <!-- Mobile Navigation -->
      <div class="mobile-nav" :class="{ open: isMenuOpen }">
        <router-link to="/?legacy=1" class="mobile-nav-item" @click="closeMenu">网站首页</router-link>
        <router-link to="/about" class="mobile-nav-item" @click="closeMenu">关于我们</router-link>
        <router-link to="/news" class="mobile-nav-item" @click="closeMenu">新闻资讯</router-link>
        <router-link to="/services" class="mobile-nav-item" @click="closeMenu">我们的服务</router-link>
        <router-link to="/verification" class="mobile-nav-item" @click="closeMenu">报告查真伪</router-link>
      </div>
    </div>
  </header>
</template>

<script>
import { ref, computed } from 'vue'
import { useRoute } from 'vue-router'

export default {
  name: 'WebsiteHeader',
  setup() {
    const route = useRoute()
    const isMenuOpen = ref(false)

    const toggleMenu = () => {
      isMenuOpen.value = !isMenuOpen.value
    }

    const closeMenu = () => {
      isMenuOpen.value = false
    }

    const isActive = (path) => {
      return route.path === path
    }

    return {
      isMenuOpen,
      toggleMenu,
      closeMenu,
      isActive
    }
  }
}
</script>

<style scoped>
.site-header {
  background-color: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 1000;
  height: 70px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo-container {
  display: flex;
  align-items: center;
}

.logo-placeholder {
  display: flex;
  align-items: center;
  font-size: 24px;
  font-weight: bold;
  color: #333;
}

.logo-img {
  height: 40px;
  margin-right: 10px;
}

.desktop-nav {
  display: flex;
  gap: 30px;
}

.nav-item {
  text-decoration: none;
  color: #333;
  font-size: 16px;
  font-weight: 500;
  transition: color 0.3s;
  padding: 5px 0;
  position: relative;
}

.nav-item:hover, .nav-item.active {
  color: #0068b7;
}

.nav-item.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #0068b7;
}

.mobile-menu-btn {
  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: 30px;
  height: 21px;
  cursor: pointer;
  z-index: 1001;
}

.bar {
  width: 100%;
  height: 3px;
  background-color: #333;
  transition: 0.3s;
  border-radius: 2px;
}

.bar.open:nth-child(1) {
  transform: translateY(9px) rotate(45deg);
}

.bar.open:nth-child(2) {
  opacity: 0;
}

.bar.open:nth-child(3) {
  transform: translateY(-9px) rotate(-45deg);
}

.mobile-nav {
  position: fixed;
  top: 0;
  right: -100%;
  width: 250px;
  height: 100vh;
  background-color: #fff;
  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
  padding-top: 80px;
  transition: right 0.3s ease-in-out;
  display: flex;
  flex-direction: column;
}

.mobile-nav.open {
  right: 0;
}

.mobile-nav-item {
  text-decoration: none;
  color: #333;
  font-size: 18px;
  padding: 15px 30px;
  border-bottom: 1px solid #f0f0f0;
}

.mobile-nav-item:hover {
  background-color: #f5f0fa;
  color: #0068b7;
}

@media (max-width: 768px) {
  .desktop-nav {
    display: none;
  }

  .mobile-menu-btn {
    display: flex;
  }
}
</style>
